// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportsTable_wrapper__lHwdU","tableGeneral":"ReportsTable_tableGeneral__K1OCj","tableGeneralHeader":"ReportsTable_tableGeneralHeader__ZChDX"};